import { FAQType } from '../components/FAQ/FAQAccordion';
// import debug from "debug";
// const d = debug("html2json");

export const isParseError = (parsedDocument: any) => {
  // parser and parsererrorNS could be cached on startup for efficiency
  var parser = new DOMParser(),
    errorneousParse = parser.parseFromString('<', 'application/xml'),
    parsererrorNS = errorneousParse.getElementsByTagName('parsererror')[0].namespaceURI;

  if (parsererrorNS === 'http://www.w3.org/1999/xhtml') {
    // In PhantomJS the parseerror element doesn't seem to have a special namespace, so we are just guessing here :(
    return parsedDocument.getElementsByTagName('parsererror').length > 0;
  }

  return parsedDocument.getElementsByTagNameNS(parsererrorNS, 'parsererror').length > 0;
};

export const extractFAQStructure = (html: string): FAQType[] => {
  const elements = [];

  // Strip out the new lines...
  html = html.replace(/\r\n|\n|\r/gm, '');

  // If string convert to document Node
  if (typeof html === 'string') {
    let docNode;
    if (window.DOMParser) {
      try {
        const parser = new DOMParser();
        docNode = parser.parseFromString(html, 'text/xml');
        if (isParseError(docNode)) {
          console.warn('Error loading FAQs');
          return [];
        }
      } catch (err) {
        console.warn('caughtpageerror', err);
      }
    } else {
      // Microsoft strikes again
      // @ts-ignore
      docNode = new ActiveXObject('Microsoft.XMLDOM');
      docNode.async = false;
      docNode.loadXML(html);
    }
    const element = docNode.firstChild;

    const numberOfItems = Math.floor(element.children.length / 2);
    for (let x = 0; x < numberOfItems; x++) {
      const FAQItem = {
        question: element.children[x * 2].innerHTML,
        answer: element.children[x * 2 + 1].firstChild.innerHTML,
      };
      elements.push(FAQItem);
      //   d("item", FAQItem);
    }
    return elements;
  }
  return [];
};
